/* eslint-disable frontApplet/enforce-jsdoc */
import AppletError from './AppletError';
import { IBaseSosErrorParams } from './SosError';

export interface IAppletOfflineCacheErrorParams extends IBaseSosErrorParams {
	kind: 'appletOfflineCacheError';
}

export default class AppletOfflineCacheError extends AppletError {
	constructor(parameters: IAppletOfflineCacheErrorParams) {
		super({
			...parameters,
			kind: 'appletError',
			type: parameters.type ? parameters.type : 'AppletOfflineCacheError',
		});
	}
}
